import type { AppThunk } from '@core/core/store'

import { getAllDomainTypesApi } from '../../api'
import { domainsSlice } from './domainTypesSlice'

const { addDomainTypes } = domainsSlice.actions

export const getDomainTypes = (): AppThunk => dispatch => {
  getAllDomainTypesApi()
    .then(types => dispatch(addDomainTypes(types)))
    .catch(console.error)
}
